import React, { useEffect } from "react";
import * as app from "../services/AppService";
import Dialog from "./PublicDialogs/Dialog";
import { RowItem } from "../models/Core/row-item";

interface Props extends RowItem {
    model: string | null | undefined;
    onChange?: (...args: any) => any;
    title?: string;
    isTable?: boolean;
    displayAsButton?: boolean;
    size?: string;
    titleClass?: string;
    noDeleteButton?: boolean;
    class?: string;
}

export default function ImageUpload(props:Props) {

    const [state, setState] = React.useState({
        show: false,
        DialogImage: '',
        ImageSrc: "#",
        file:"",
        showImgCard: false
    });

    useEffect(() => {
        let ImageSrc = !props.model || props.model.length == 0 ? "#" : props.model.includes("data:") ? props.model :
            (props.model.startsWith("JVBERi0xLj") ? "data:application/pdf;base64," : "data:image/jpeg;base64,") + props.model;
        setState(old => ({
            ...old,
            showImgCard: props.model && props.model.length > 0 ? true : false,
            ImageSrc,
            file: ImageSrc
        }));
    }, [props.model]);

    function readURL(event:any) {
        var input = event.target;
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = function (e) {
                var ImageSrc = e.target!.result; 
                if (props.onChange && typeof (props.onChange) == "function")
                    //@ts-ignore
                    props.onChange(e.target.result.split("base64,")[1], input.files[0].name)

                setState(old => ({ ...old, showImgCard: true, ImageSrc, file: ImageSrc } as any));
            };
            reader.readAsDataURL(input.files[0]);
            if (props.displayAsButton) {
                const fileChosen = document.getElementById("fileChosen")!;
                fileChosen.textContent = input.files[0].name;
            }
        } else {
            removeUpload();
        }
    }

    function openDialog() {
        if (state.file.split("base64,")[0].includes("image"))
            setState(old => ({
                ...old, show: true,
                DialogImage: (<img className="card-img-top" src={old.ImageSrc} alt="" id={"file-upload-image" + props.title} />)
            } as any))
        else {
            const fileWindow = window.open("")!;
            fileWindow.document.write("<iframe width='100%' height='100%' src='" + encodeURI(state.file) + "'></iframe>");
        }
    }

    function removeUpload() {
        setState(old => ({ ...old, ImageSrc: "#", showImgCard: false }));
        if (props.onChange && typeof (props.onChange) == "function")
            props.onChange("")
    }

    if (props.displayAsButton) {
        return (
            <div className="row">
                <div className={"col-12 d-flex align-items-center gap-2 " + props.class}>

                    <label className="w-auto form-control" htmlFor={"img-upload-input" + props.title}>
                        {app.translate(props.title)}
                        <span className="iconssc-cloud ms-2"></span>
                    </label>
                    <input className="d-none" id={"img-upload-input" + props.title} type='file' onChange={readURL} accept="image/*"   />
                    <span id="fileChosen" className="col-auto"></span>

                </div>
            </div>
        );
    } else {
        return (
            <div className="row">
                <div>
                    {props.title && <h6 className={`text-primary-emphasis ${props.titleClass}`}>{app.translate(props.title)}</h6>}

                    <div className={`card bg-body border-primary-subtle card-primary-subtle text-center ${props.isTable ? "row mx-2" : ""}`} style={{ "width": props.isTable ? "50px" : (props.size || '').length > 0 ? "100px" : "200px", "height": props.isTable ? "50px" : (props.size || '').length > 0 ? "100px" : "200px" }}>

                        {!state.showImgCard &&
                            <div id={"image-upload-wrap" + props.title}>
                                <div className="text-primary-emphasis card-img-overlay d-flex align-items-center  flex-column">
                                    <i className={`iconssc-upload  ${!props.isTable ? 'fs-1 mt-4 ' : 'fs-4'}`}></i>
                                    {(!props.isTable && !props.size) &&
                                        <h5 >{app.translate("UploadImage")}</h5>
                                    }
                                </div>

                                <input className="form-control " id={"img-upload-input" + props.title} type='file'
                                    onChange={readURL} accept="image/*" style={{ "height": props.isTable ? "50px" : (props.size||'').length > 0 ? "100px" : "200px", "opacity": "0" }} />
                            </div>}

                        {state.showImgCard &&
                            <div className="card-body p-0">
                                <img className="card-img-top rounded" style={{ "height": props.isTable ? "50px" : (props.size || '').length > 0 ? "100px" : "148px" }} src={state.ImageSrc} alt="" id={"file-upload-image" + props.title} />
                            </div>}

                        {state.showImgCard &&
                            <div className={`${props.size =="sm"?"position-absolute bg-opacity-50 w-100 fixed-bottom":""}  card-footer ${!props.isTable ? 'bg-white' : 'col bg-transparent border-0 py-0 px-3 w-auto'}`}>
                                <div className="row">
                                    {!props.noDeleteButton && <button type="button" onClick={removeUpload} className={`btn btn-sm btn-outline-danger rounded-1 mx-1 ${!props.isTable ? 'col' : 'p-0'}`}><i className="iconssc-trash"></i></button>}
                                    <button type="button" onClick={openDialog} className={`btn btn-sm btn-outline-primary rounded-1 mx-1 ${!props.isTable ? 'col' : 'p-0'}`}><i className="iconssc-eye"></i></button>
                                </div>
                            </div>}
                    </div>
                    <Dialog show={state.show} size="md" onClose={() => setState(old => ({ ...old, show: false }))}>
                        {state.DialogImage as any}
                    </Dialog>
                </div>
            </div>
        );
    }
}


ImageUpload.defaultProps = {
    model: "",
    title: "",
    isTable: false,
    displayAsButton: false,
    size: "",
    titleClass: "",
    noDeleteButton: false
};
